module.exports = __webpack_public_path__ + "img/Flying_kid.b15a6dfc.png";